import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import Moment from 'moment'
import { GenericMoreButton } from 'components';
import { Chart } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  chart: {
    padding: theme.spacing(4, 2, 0, 2),
    height: 400
  }
}));

const FinancialStats = props => {
  const { className, earningsInfos, ...rest } = props;

  let data = []
  let labels = []

  const classes = useStyles();

  if (earningsInfos.length < 31) {
    data = earningsInfos.map((earning, index) => {
      return earning.refundablePartner
    })
    labels = earningsInfos.map((earning, index) => {
      return Moment(earning.date, 'X').format('l')
    })
  } else {
    //On regroupe tous les jours par mois
    const earningsByMonth = Object.values(earningsInfos.reduce((acc, booking) => {
      const bookingMonth = Moment(booking.date, 'X').startOf('month').format('X')

      if (acc[bookingMonth]) {
        return {
          ...acc,
          [bookingMonth]: {
            date: bookingMonth,
            totalPaid: acc[bookingMonth].totalPaid + booking.totalPaid,
            totalPrice: acc[bookingMonth].totalPrice + booking.totalPrice,
            sumPaidWithCredits: acc[bookingMonth].sumPaidWithCredits + booking.sumPaidWithCredits,
            refundablePartner: acc[bookingMonth].refundablePartner + booking.refundablePartner,
          },
        }
      } else {
        return {
          ...acc,
          [bookingMonth]: {
            date: bookingMonth,
            totalPaid: booking.totalPaid,
            totalPrice: booking.totalPrice,
            sumPaidWithCredits: booking.sumPaidWithCredits,
            refundablePartner: booking.refundablePartner,
          },
        }
      }
    }, {})).sort((a, b) => {
      if (a.date > b.date) {
        return 1
      }
      if (a.date < b.date) {
        return -1
      }
      return 0
    })
    data = earningsByMonth.map((earning, index) => {
      return earning.refundablePartner
    })
    labels = earningsByMonth.map((earning, index) => {
      return Moment(earning.date, 'X').format('MMM')
    })
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={<GenericMoreButton />}
        title="Earnings"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Chart
              className={classes.chart}
              data={data}
              labels={labels}
            />
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

FinancialStats.propTypes = {
  earningsInfos: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string
};

export default FinancialStats;
